import React, { useState } from "react";

const navItems = ["home", "portfolio", "music", "about", "contact"];

const Header = () => {
  const [open, setOpen] = useState(false);

  return (
    <header className="site-header">
      <nav className="nav-desktop">
        {navItems.map((id) => (
          <a key={id} href={`#${id}`} className="nav-link">{id}</a>
        ))}
      </nav>

      <div className="nav-mobile">
        <button className="nav-toggle" onClick={() => setOpen(!open)} aria-label="Toggle navigation">
          <span className="nav-toggle-label">{open ? "Close" : "Menu"}</span>
          <span className={`nav-hamburger ${open ? "is-open" : ""}`}>
            <span /><span /><span />
          </span>
        </button>
        {open && (
          <div className="nav-drawer">
            {navItems.map((id) => (
              <a key={id} href={`#${id}`} className="nav-drawer-link" onClick={() => setOpen(false)}>
                {id}
              </a>
            ))}
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
